import styled from 'styled-components';
//
import Layout from '../../components/Layout';
import { Subtitle, Title } from '../../components/ui';
import ContactUsForm from '../../components/ContactUsForm';
import { useEffect, useState } from 'react';
import { getCMS } from '../../api/services/systemService';
//

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: center; */
  padding: 5rem 0;
  gap: 2%;
  width: 100%;
  max-width: 100%;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
`;

const DescText = styled.p`
  font-size: 20px;
  font-weight: 700;
  white-space: pre;
  text-align: center;
`;

export default function ContactUsPage() {
  useEffect(() => {
    getDbCMS();
  }, []);

  const [content, setContent] = useState({
    title: '',
    contents: '',
  });

  const getDbCMS = async () => {
    const result = await getCMS('02');
    setContent(result.cms);
  };

  return (
    <Layout>
      <Container>
        <Title style={{ marginBottom: '30px' }}>{content.title}</Title>
        <TextContainer>
          <div dangerouslySetInnerHTML={{ __html: content.contents }} />
        </TextContainer>
        <ContactUsForm style={{ width: '50%' }} />
      </Container>
    </Layout>
  );
}
